// frontend/src/p2pAxios.js
import axios from "axios";

const baseURL =
  process.env.NODE_ENV === "production"
    ? "https://api.coinzetto.com/api/p2p"
    : "http://localhost:5000/api/p2p";

const p2pAxios = axios.create({
  baseURL,
  withCredentials: true,
});

// Automatically attach token from localStorage
p2pAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ✅ Redirect to P2P Profile (username setup) when blocked by backend
p2pAxios.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const data = err?.response?.data || {};

    const code = data.code;
    const msg = String(data.message || data.error || "");

    const isUsernameRequired =
      (status === 403 && code === "P2P_USERNAME_REQUIRED") ||
      (status === 403 && msg.toLowerCase().includes("p2p username"));

    if (isUsernameRequired) {
      // 🔒 mark forced flow (profile page will auto-open editor)
      sessionStorage.setItem("p2p_force_username", "1");

      // ✅ store where user came from so we can send them back after saving
      sessionStorage.setItem(
        "p2p_next_after_username",
        window.location.pathname + window.location.search
      );

      // ✅ redirect to profile page
      if (!window.location.pathname.startsWith("/p2p/profile")) {
        window.location.assign("/p2p/profile");
      }
    }

    return Promise.reject(err);
  }
);

export default p2pAxios;
